namespace Portico.Models.Setup {

    export interface IDataTable {
		id: string;
        name: string;
		createdBy: number;
		createdOn: Date;
        dataColumns: DataColumn[];

		getDataColumn(column: string): DataColumn;
	}

    export class DataTable implements IDataTable {
		id: string;
        name: string;
		createdBy: number;
		createdOn: Date;

        dataColumns: DataColumn[];

        constructor(obj?: IDataTable) {
            this.id = null;
            this.name = null;
			this.createdBy = null;
			this.createdOn = null;

            this.dataColumns = [];

            if (obj) {
                this.id = obj.id;
                this.name = obj.name;
				this.createdBy = obj.createdBy;
				this.createdOn = obj.createdOn ? new Date(typeof obj.createdOn === 'string' && (<string>obj.createdOn).charAt(10) === 'T' ? obj.createdOn + 'Z' : obj.createdOn) : null;

                if (obj.dataColumns) {
                    for (const dataColumn of obj.dataColumns) {
                        this.dataColumns.push(new DataColumn(dataColumn));
                    }
                }
            }
        }

		getDataColumn(column: string): DataColumn {
			const dataColumns = this.dataColumns.filter((dc: DataColumn) => {
				return dc.id === column || dc.name === column;
			});

			if (dataColumns && dataColumns.length === 1) {
				return dataColumns[0];
			}

			return null;
		}
    }
}